import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.update-incidents-anzeige-mandant-options';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsUpdateIncidentsAnzeigeMandantOptionsEffects {

    UpdateIncidentsAnzeigeMandantOptions$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_UPDATE_INCIDENTS_ANZEIGE_MANDANT_OPTIONS),
        mergeMap((x: ac.PostUpdateIncidentsAnzeigeMandantOptionsAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postUpdateIncidentsAnzeigeMandantOptions(x.incidentsAnzeigeMandantOptions).pipe(
                map((result: any) => {
                    return new ac.PostUpdateIncidentsAnzeigeMandantOptionsErfolgreichAction(x.incidentsAnzeigeMandantOptions, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostUpdateIncidentsAnzeigeMandantOptionsFehlerAction(error, x.incidentsAnzeigeMandantOptions, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsCommandService);
        }
        return this.service;
    }
}
